import React from 'react';
import FilterBar from '../FilterBar/FilterBar';
import ProductFiltering from '../ProductFiltering/ProductFiltering';
import ProductListing from '../ProductListing/ProductListing';
import SearchResultLinkTab from './SearchResultLinkTab';
import { useTypedSelector } from '../../Hooks/useTypedSelector';

const SearchResult = (props) => {
  const { activeTab = 'products' } = useTypedSelector<any>(
    (state) => state.search
  );

  return (
    <>
      {props.productListing?.totalProductsCount > 0 &&
        activeTab == 'products' && (
          <div className="container grid grid-cols-5 gap-4 pb-6 lg:gap-6 lg:pb-8 xl:pb-10">
            <aside className="col-span-1 hidden lg:block">
              <ProductFiltering />
            </aside>
            <div className="col-span-5 lg:col-span-4">
              <FilterBar />
              <ProductListing />
            </div>
          </div>
        )}
      {props.brandListing?.total > 0 && activeTab == 'brands' && (
        <SearchResultLinkTab items={props.brandListing.items} />
      )}
      {props.pagesListing?.total > 0 && activeTab == 'pages' && (
        <SearchResultLinkTab items={props.pagesListing.items} />
      )}
      {props.categoryListing?.total > 0 && activeTab == 'categories' && (
        <SearchResultLinkTab items={props.categoryListing.items} />
      )}
    </>
  );
};

export default SearchResult;
